import { ArrayElement } from 'dibs-ts-utils/exports/ArrayElement';

type Item = {
    skus: readonly ({ serviceId: string | null } | null)[] | null;
};

export const getSelectedSku = <T extends Item>(
    item: T,
    skuId: string | null
): ArrayElement<T['skus']> | undefined => {
    if (!skuId || !item?.skus) {
        return undefined;
    }

    return item?.skus.find((sku): sku is ArrayElement<T['skus']> => sku?.serviceId === skuId);
};
